/* @flow */

import React from 'react'

import NavContainer from '../containers/NavContainer'

import Link from 'gatsby-link'

import '../css/components/Nav.scss'
import Disclaimer from './Disclaimer'
import DisclaimerContainer from '../containers/DisclaimerContainer'

const linkCx: string = 'sub-menu-item no-underline'

const hamStyl: Object = Object.freeze({
  borderRadius: '5px',
  height: '3px',
  marginTop: '-1px',
  transformOrigin: 'center center 0',
  transition: '0.3s ease',
})

type tPROPS = {
  showMobileNav: boolean;
  toggleMobileNav: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  closeMobileNav: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  toggleDropdownContent: (event: React.TouchEvent<HTMLSpanElement>) => void;
  hideDropdownContent: React.MouseEventHandler<HTMLDivElement>;
  showDropdownContent: React.MouseEventHandler<HTMLDivElement>;
  handleOpenModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  activeDropdown: string;
  path: string;
  validated: boolean;
};

const Nav = (props: tPROPS) => {
  const {
    showMobileNav,
    toggleMobileNav,
    closeMobileNav,
    toggleDropdownContent,
    hideDropdownContent,
    showDropdownContent,
    handleOpenModal,
    activeDropdown,
    path,
    validated
  } = props

  const navCx = `
  bg-white col d-5 flex-row 
  ${!showMobileNav ? 'tab-hide' : ''}
`

  const WrappedDisclaimer = DisclaimerContainer(Disclaimer)

  return (
    <nav className='bg-white clr-gray flex-box dir-column main-nav-bar'>
      <WrappedDisclaimer validated={validated}/>
      <a
        href='#hero'
        className='visually-hidden'>
        Skip navigation, go to start of content
      </a>
      <div>
        <div className='container dir-column tab-pad-b-1 tab-pad-t-1 nav-bar'>
          <div className={showMobileNav ? 'dir-column relative' : 'flex-row relative'}>
            <div className='container d-40 align-center logo-wrapper relative'>
              <Link
                className='nav-logos'
                to='/'>
                {/* <img
                  alt='Go to FDA website'
                  src='/img/FDA_logo_blue.png'
                  className='fda-logo'
                />
                <div className="nav-bar-divider-line"/>*/}
                <img
                  className='open-fda-logo'
                  alt='Go to openFDA homepage'
                  src='/img/l_openFDA.png'
                />
              </Link>
              <div
                className='absolute right d-hide'
                onClick={toggleMobileNav}
                style={{
                  height: '25px',
                  transform: 'rotate(0deg)',
                  width: '36px',
                }}
              >
                <span
                  className='absolute bg-primary block row'
                  style={{
                    ...hamStyl,
                    transform: showMobileNav ?
                      'translate3d(0, 10px, 0) rotate(45deg)' :
                      'translate3d(0, 0, 0) rotate(0deg)',
                  }}
                />
                <span
                  className='absolute bg-primary block row'
                  style={{
                    ...hamStyl,
                    transform: 'translate3d(0, 10px, 0)',
                    opacity: showMobileNav ? 0 : 1,
                  }}
                />
                <span
                  className='absolute bg-primary block row'
                  style={{
                    ...hamStyl,
                    transform: showMobileNav ?
                      'translate3d(0, 10px, 0) rotate(-45deg)' :
                      'translate3d(0, 20px, 0) rotate(0deg)',
                  }}
                />
              </div>
            </div>
            <div className={navCx}>
              <div className='menu-container responsive-header' role='navigation'>
                <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                  <Link
                    title='Home'
                    to='/'
                    className={path === '/' ? 'menu-header header-selected emphasis' : activeDropdown === 'Home' ? 'menu-header emphasis' : 'menu-header'}
                    onClick={closeMobileNav}
                  >Home</Link>
                  <div className={path === '/' ? 'menu-header-underbar' : 'menu-header-underbar display-none'} style={{width: 'calc(100% - 1em)'}}/>
                </div>
                <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                  <span
                    title='About'
                    className={path.indexOf('about') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'About' ? 'menu-header emphasis' : 'menu-header'}
                    onTouchStart={toggleDropdownContent}
                  >About <i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                  <div className={path.indexOf('about') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none'}/>
                  <div className={activeDropdown === 'About' ? 'dropdown-content display-block' : 'dropdown-content display-none'}>
                    <div className='sub-menu-container' role='navigation'>
                      <Link className={linkCx} to='/about/' onClick={closeMobileNav}>What is openFDA?</Link>
                      <Link className={linkCx} to='/about/updates/' onClick={closeMobileNav}>Updates</Link>
                      <Link className={linkCx} to='/about/status/' onClick={closeMobileNav}>API status</Link>
                      <Link className={linkCx} to='/about/statistics/' onClick={closeMobileNav}>API usage statistics</Link>
                    </div>
                  </div>
                </div>
                <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                  <span
                    title='APIs'
                    className={path.indexOf('apis') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'APIs' ? 'menu-header emphasis' : 'menu-header'}
                    onTouchStart={toggleDropdownContent}
                  >APIs<i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                  <div className={path.indexOf('apis') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none'}/>
                  <div className={activeDropdown === 'APIs' ? 'dropdown-content display-block' : 'dropdown-content display-none'}>
                    <div className='sub-menu-container' role='navigation'>
                      <Link className={linkCx} to='/apis/' onClick={closeMobileNav}>API basics</Link>
                      <Link className={linkCx} to='/apis/animalandveterinary/' onClick={closeMobileNav}>Animal and Veterinary Endpoints</Link>
                      <Link className={linkCx} to='/apis/drug/' onClick={closeMobileNav}>Drug Endpoints</Link>
                      <Link className={linkCx} to='/apis/device/' onClick={closeMobileNav}>Device Endpoints</Link>
                      <Link className={linkCx} to='/apis/food/' onClick={closeMobileNav}>Food Endpoints</Link>
                      <Link className={linkCx} to='/apis/cosmetic/' onClick={closeMobileNav}>Cosmetic Endpoints</Link>
                      <Link className={linkCx} to='/apis/other/' onClick={closeMobileNav}>Other Endpoints</Link>
                      <Link className={linkCx} to='/apis/research/' onClick={closeMobileNav}>Research Endpoints</Link>
                      <Link className={linkCx} to='/apis/tobacco/' onClick={closeMobileNav}>Tobacco Endpoints</Link>
                      <Link className={linkCx} to='/apis/transparency/' onClick={closeMobileNav}>Transparency Endpoints</Link>
                    </div>
                  </div>
                </div>
                <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                  <span
                    title='Data'
                    className={path.indexOf('data') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'Data' ? 'menu-header emphasis' : 'menu-header'}
                    onTouchStart={toggleDropdownContent}
                  >Data <i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                  <div className={path.indexOf('data') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none'}/>
                  <div className={activeDropdown === 'Data' ? 'dropdown-content display-block' : 'dropdown-content display-none'}>
                    <div className='sub-menu-container' role='navigation'>
                      <Link className={linkCx} to='/data/datadictionary' onClick={closeMobileNav}>Data Dictionary</Link>
                      <Link className={linkCx} to='/data/downloads/' onClick={closeMobileNav}>Downloads</Link>
                      <Link className={linkCx} to='/data/science/' onClick={closeMobileNav}>Data Science & Analytics</Link>
                      <Link className={linkCx} to='/data/scientificdatasets/' onClick={closeMobileNav}>Scientific Datasets</Link>
                      <Link className={linkCx} to='/data/transparencytools' onClick={closeMobileNav}>Transparency Tools</Link>
                    </div>
                  </div>
                </div>
                <div className='dropdown' onMouseLeave={hideDropdownContent} onMouseEnter={showDropdownContent}>
                  <span
                    title='Community'
                    className={path.indexOf('community') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'Community' ? 'menu-header emphasis' : 'menu-header'}
                    onTouchStart={toggleDropdownContent}
                  >Community <i className={"fa fa-angle-down " + (showMobileNav ? 'display-none' : '')}/></span>
                  <div className={path.indexOf('community') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none'}/>
                  <div className={activeDropdown === 'Community' ? 'dropdown-content display-block' : 'dropdown-content display-none'}>
                    <div className='sub-menu-container' role='navigation'>
                      <a
                        className={`${linkCx}`}
                        href='https://github.com/FDA'
                        onClick={closeMobileNav}
                        rel='noopener noreferrer'
                        target='_blank'>
                        Source code (GitHub)
                      </a>
                      <a
                        className={`${linkCx}`}
                        href='https://opendata.stackexchange.com/questions/tagged/openfda'
                        onClick={closeMobileNav}
                        rel='noopener noreferrer'
                        target='_blank'>
                        Q&A (StackExchange)
                      </a>
                      <Link className={linkCx} to='/community/' onClick={closeMobileNav}>openFDA Apps</Link>
                    </div>
                  </div>
                </div>
                <div className='dropdown'>
                  <button
                    title='Disclaimer'
                    onClick={(e) => {handleOpenModal(e)
                      e.stopPropagation()
                      sessionStorage.setItem('hasSeenDisclaimer', 'false')
                      sessionStorage.setItem('validated', 'false')
                    }}
                    className={activeDropdown === 'Home' ? 'menu-header emphasis' : 'menu-header'}
                  >Disclaimer</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

Nav.displayName = 'components/Nav'
export default NavContainer(Nav)
